<div>
    <h2>{{'historico-totales.titulo' | translate}}</h2>
    <div class="filters-info" *ngIf="filtersVisible">{{'global.infoRequired' | translate}}</div>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}} *</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')"
                    [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-totales.filters.denominacion' | translate}} *</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [disabled]="disabledDenominaciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-totales.filters.campanya' | translate}} *</label>
                <app-filterable-list [itemsList]="campanyas" [selectedItem]="filtersForm.get('campanya')"
                    [disabled]="disabledCampanyas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-totales.filters.marca' | translate}}</label>
                <app-filterable-list [itemsList]="marcas" [selectedItem]="filtersForm.get('marca')"
                    [disabled]="disabledMarcas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-totales.filters.destino' | translate}}</label>
                <app-filterable-list [itemsList]="destinos" [selectedItem]="filtersForm.get('paisDestino')"
                    [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}"
                    formControlName="fechaInicio" (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}"
                    formControlName="fechaFin" (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <input type="checkbox" id="desglosePaisDestino" formControlName="desglosePaisDestino">
                <label for="desglosePaisDestino">{{'historico-totales.filters.mostrarDesglose' | translate}}</label>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <input type="checkbox" id="fechasImpresion" formControlName="fechasImpresion">
                <label for="fechasImpresion">{{'historico-totales.filters.mostrarFechas' | translate}}</label>
            </div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
        <i class="fas fa-file-pdf" [ngClass]="{'disabled': !historicoTotales}"
            (click)="exportarPdfOrExcel('pdf')" title="{{'titles.exportarPDF' | translate}}"></i>
        <i class="fa-solid fa-circle-question" (click)="openDocHelp()"
            title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <content class="tabs" *ngIf="historicoTotales">
        <form>
            <h3>{{'historico-totales.tabs.totalEtiquetas.titulo' | translate}}</h3>
            <section class="info-framed">
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'global.confeccionado' | translate}}</label>
                    <span>{{historicoTotales.totalNumEtiquetas ? (historicoTotales.totalNumEtiquetas | number : '' :
                        defaultLanguage) : 0}}</span>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'historico-totales.tabs.totalEtiquetas.reetiquetado' | translate}}</label>
                    <span>{{historicoTotales.totalNumEtiquetasReimpresas ? (historicoTotales.totalNumEtiquetasReimpresas
                        | number : '' :
                        defaultLanguage) : 0}}</span>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'historico-totales.tabs.totalEtiquetas.totalEtiquetas' | translate}}</label>
                    <span>{{historicoTotales.totalNumEtiquetas ? (historicoTotales.totalNumEtiquetas +
                        historicoTotales.totalNumEtiquetasReimpresas
                        | number : '' : defaultLanguage) : 0}}</span>
                </div>
            </section>
            <h3>{{'historico-totales.tabs.totalKilos.titulo' | translate}}</h3>
            <section class="info-framed">
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'historico-totales.tabs.totalKilos.designados' | translate}}</label>
                    <span>{{historicoTotales.totalKgDesignados ? (historicoTotales.totalKgDesignados | number : '1.2-2':
                        defaultLanguage) :
                        0}}</span>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'global.confeccionadoKg' | translate}}</label>
                    <span>{{historicoTotales.totalKgImpresos ? (historicoTotales.totalKgImpresos | number : '1.2-2':
                        defaultLanguage) : 0}}</span>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'historico-totales.tabs.totalKilos.reetiquetado' | translate}}</label>
                    <span>{{historicoTotales.totalKgReimpresos ? (historicoTotales.totalKgReimpresos | number : '1.2-2':
                        defaultLanguage) :
                        0}}</span>
                </div>
            </section>
        </form>
        <div class="table-wrapper">
            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <th class="id sortable" (click)="toOrderBy('x=> x.etiquetadorId', 1)">
                                {{'historico-totales.table.id' | translate}}
                                <i [ngClass]="getIcon('x=> x.etiquetadorId')"></i>
                            </th>
                            <th class="string sortable" (click)="toOrderBy('x=> x.desPais', 2)">
                                {{'global.pais' | translate}}
                                <i [ngClass]="getIcon('x=> x.desPais')"></i>
                            </th>
                            <th class="string sortable" (click)="toOrderBy('x=> x.desDenominacion', 3)">
                                {{'historico-totales.table.denominacion' | translate}}
                                <i [ngClass]="getIcon('x=> x.desDenominacion')"></i>
                            </th>
                            <th class="string sortable" (click)="toOrderBy('x=> x.desEtiquetador', 4)">
                                {{'historico-totales.table.etiquetador' | translate}}
                                <i [ngClass]="getIcon('x=> x.desEtiquetador')"></i>
                            </th>
                            <th class="string sortable" (click)="toOrderBy('x=> x.anyo', 5)">
                                {{'historico-totales.table.campanya' | translate}}
                                <i [ngClass]="getIcon('x=> x.anyo')"></i>
                            </th>
                            <th class="string sortable" *ngIf="destino" (click)="toOrderBy('x=> x.paisDestinoISO3', 6)">
                                {{'historico-totales.table.destino' | translate}}
                                <i [ngClass]="getIcon('x=> x.paisDestinoISO3')"></i>
                            </th>
                            <th class="date sortable sortable-biggest" *ngIf="fechasImpresion"
                                (click)="toOrderBy('x=> x.fechaImpresionPrimerConsumo', indexOrderFecha)">
                                <span [innerHTML]="('historico-totales.table.primerConsumo' | translate)" class="m-right"></span>
                                <i [ngClass]="getIcon('x=> x.fechaImpresionPrimerConsumo')"></i>
                            </th>
                            <th class="date sortable sortable-biggest" *ngIf="fechasImpresion"
                                (click)="toOrderBy('x=> x.fechaImpresionUltimoConsumo', indexOrderFecha+1)">
                                <span [innerHTML]="('historico-totales.table.ultimoConsumo' | translate)" class="m-right"></span>
                                <i [ngClass]="getIcon('x=> x.fechaImpresionUltimoConsumo')"></i>
                            </th>
                            <th class="number sortable" (click)="toOrderBy('x=> x.sumaKgDesignados', indexOrder)">
                                {{'historico-totales.table.designados' | translate}}
                                <i [ngClass]="getIcon('x=> x.sumaKgDesignados')"></i>
                            </th>
                            <th class="number sortable sortable-biggest" (click)="toOrderBy('x=> x.sumaKgImpresosEfectivos', indexOrder+1)">
                                <span [innerHTML]="('global.confeccionadoKg' | translate)" class="m-right"></span>
                                <i [ngClass]="getIcon('x=> x.sumaKgImpresosEfectivos')"></i>
                            </th>
                            <th class="number sortable sortable-biggest" (click)="toOrderBy('x=> x.sumaKgReimpresos', indexOrder+2)">
                                <span [innerHTML]="('historico-totales.table.reetiquetado' | translate)" class="m-right"></span>
                                <i [ngClass]="getIcon('x=> x.sumaKgReimpresos')"></i>
                            </th>
                            <th class="number sortable sortable-biggest"
                                (click)="toOrderBy('x=> x.sumaNumEtiquetasImpresasEfectivas', indexOrder+3)">
                                <span [innerHTML]="('historico-totales.table.confeccionEtq' | translate)" class="m-right"></span>
                                <i [ngClass]="getIcon('x=> x.sumaNumEtiquetasImpresasEfectivas')"></i>
                            </th>
                            <th class="number sortable sortable-biggest" (click)="toOrderBy('x=> x.sumaNumEtiquetasReimpresas', indexOrder+4)">
                                <span [innerHTML]="('historico-totales.table.reetiquetadoEtq' | translate)" class="m-right"></span>
                                <i [ngClass]="getIcon('x=> x.sumaNumEtiquetasReimpresas')"></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let total of historicoTotales.lsTotales; let i = index;">
                        <tr *ngIf="i < lastItemList && i >= firstItemList">
                            <td class="id">{{total.etiquetadorId}}</td>
                            <td class="string">{{total.desPais}}</td>
                            <td class="string">{{total.desDenomacion}}</td>
                            <td class="string">{{total.desEtiquetador}}</td>
                            <td class="string">{{total.anyo}}</td>
                            <td class="string" *ngIf="destino">{{total.paisDestinoISO3 ? total.paisDestinoISO3 : 'Sin Destino'}}
                            </td>
                            <td class="date-longest" *ngIf="fechasImpresion">{{total.fechaImpresionPrimerConsumo | date:"dd/MM/yyyy
                                hh:mm:ss"}}</td>
                            <td class="date-longest" *ngIf="fechasImpresion">{{total.fechaImpresionUltimoConsumo | date:"dd/MM/yyyy
                                hh:mm:ss"}}</td>
                            <td class="number">{{total.sumaKgDesignados ? (total.sumaKgDesignados | number : '1.2-2':
                                defaultLanguage) :
                                0}}</td>
                            <td class="number-longest">{{total.sumaKgImpresosEfectivos ? (total.sumaKgImpresosEfectivos | number :
                                '1.2-2': defaultLanguage) : 0}}</td>
                            <td class="number-longest">{{total.sumaKgReimpresos ? (total.sumaKgReimpresos | number : '1.2-2':
                                defaultLanguage) :
                                0}}</td>
                            <td class="number-longest">{{total.sumaNumEtiquetasImpresasEfectivas ?
                                (total.sumaNumEtiquetasImpresasEfectivas | number : '' : defaultLanguage) : 0}}</td>
                            <td class="number-longest">{{total.sumaNumEtiquetasReimpresas ? (total.sumaNumEtiquetasReimpresas | number :
                                '' : defaultLanguage) : 0}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <app-paginator
            *ngIf="(historicoTotales && historicoTotales.lsTotales.length > 0) || (historicoTotales && historicoTotales.lsTotales.length > 0)"
            [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
            [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
            (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    </content>
    <section *ngIf="!historicoTotales || historicoTotales.length === 0">
        <div class="no-data">{{'global.noContent' | translate}}</div>
    </section>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes"
        (closed)="showError=$event;showWarning=$event">
    </app-toast>
</div>